module.exports = __webpack_public_path__ + "static/media/Mars9.07bfed0c.jpg";